import script from "./HeaderFastenaktion.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderFastenaktion.vue?vue&type=script&setup=true&lang=js"

import "./HeaderFastenaktion.vue?vue&type=style&index=0&id=dd0e8fe8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd0e8fe8"]])

export default __exports__